export const ROOT = '/'

export const LOGOUT = `${ROOT}logout`

export const LEGAL = `${ROOT}legal`
export const CUSTOMER_AGREEMENT_AND_POLICIES = `${LEGAL}/customer-agreement-and-policies`

export const HOME = `${ROOT}`
export const FEATURES = `${ROOT}features`
export const USE_CASES = `${ROOT}use-cases`
export const PRICING = `${ROOT}pricing`
export const AFFILIATE = `${ROOT}affiliate`
export const HELP_CENTER = `${ROOT}help-center`
export const BECOME_PARTNER = `${ROOT}become-partner`
export const SUBMIT_REFERRAL = `${ROOT}submit-referral`
export const HELP_CENTER_SECTION = (slug?: string) =>
  `${HELP_CENTER}/${slug || ':section*'}`
export const FEATURE = (slug?: string) => `${FEATURES}/${slug || ':feature*'}`
export const USE_CASE = (slug?: string) => `${USE_CASES}/${slug || ':useCase*'}`

export const CHAT_SDK = `${ROOT}chat-sdk`
export const CHAT_SDK_COMMUNITY = `${CHAT_SDK}/community`

export const API = `${ROOT}api`

export const AUTH = `${ROOT}auth`

export const SIGN_UP = `${AUTH}/sign-up`
export const LOGIN = `${AUTH}/login`
export const VERIFY = `${AUTH}/verify`
export const VERIFY_EMAIL = `${AUTH}/verify-email`
export const FORGOT_PASSWORD = `${AUTH}/forgot-password`
export const RESET_PASSWORD = `${AUTH}/reset-password`
export const PHONE_VERIFICATION = `${AUTH}/phone-verification`
export const TOTP_VERIFICATION = `${AUTH}/totp-verification`
export const CREATE_PASSWORD = `${AUTH}/create-password`

export const REQUEST_DEMO = `${ROOT}request-demo`

export const APP = `${ROOT}app`

export const SITEMAP = `${ROOT}sitemap`
